const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20widescreen%20composition%20with%20deep%20charcoal%20and%20warm%20golden%20accents%2C%20elegant%20film%20frame%20aesthetic%20with%20soft%20light%20streaks%2C%20modern%20digital%20art%20style%20evoking%20premium%20video%20streaming%2C%20sophisticated%20dark%20atmosphere%20with%20luminous%20highlights%2C%20clean%20minimal%20composition&width=900&height=506&seq=media-rv-01&orientation=landscape',
    tag: '蜜桃视频 · 热门播放',
    title: '本月最受欢迎蜜桃视频独家内容一览',
    views: '12.8万',
    duration: '合集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20widescreen%20composition%20with%20rich%20burgundy%20and%20dark%20obsidian%20tones%2C%20elegant%20film%20aesthetic%20with%20dramatic%20lighting%2C%20modern%20art%20style%20suggesting%20curated%20entertainment%20content%2C%20sophisticated%20dark%20background%20with%20warm%20glowing%20elements&width=900&height=506&seq=media-rv-02&orientation=landscape',
    tag: '红桃视频 · 编辑力荐',
    title: '红桃视频编辑团队精选高分作品专题',
    views: '9.6万',
    duration: '合集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20widescreen%20composition%20with%20copper%20and%20deep%20charcoal%20color%20palette%2C%20elegant%20modern%20film%20aesthetic%20with%20soft%20atmospheric%20highlights%2C%20digital%20art%20style%20representing%20premium%20streaming%20platform%2C%20sophisticated%20dark%20ambiance%20with%20refined%20luminous%20details&width=900&height=506&seq=media-rv-03&orientation=landscape',
    tag: '香蕉视频 · VIP免费',
    title: '香蕉视频VIP频道免费内容全览指南',
    views: '18.3万',
    duration: '合集',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            蜜桃视频、红桃视频、香蕉视频三大品牌频道精彩内容速览
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-950/60 group-hover:bg-primary-500/80 transition-all duration-300 cursor-pointer">
                    <i className="ri-play-fill text-2xl md:text-3xl text-foreground-50 ml-1"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full bg-background-950/70 text-foreground-200 whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-300 bg-background-950/60 px-2 py-1 rounded">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs text-primary-400 font-medium">{item.tag}</span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 mt-1 font-heading line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}